import { render, staticRenderFns } from "./LegalPaymentNotice.vue?vue&type=template&id=31c3468e&"
import script from "./LegalPaymentNotice.vue?vue&type=script&lang=js&"
export * from "./LegalPaymentNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports